export default String.raw`
.newsSection {
    padding: 0 32px;

    &__container {
        &::before {
            visibility: hidden;
        }
    
        &::after {
            visibility: hidden;
        }
    }

    &__arrows {
        visibility: hidden;
    }

    &__slide {
        width: calc(100% / 2.6);
    }
}
`